import { useMemo } from "react";
import {
    createDictationSaveTracker,
    DictationSaveTracker,
    DictationSource,
} from "util/dictation-save-tracker";
import { handleEvent } from "util/user-events";

export const useDictationSaveTracker = (source: DictationSource): DictationSaveTracker =>
    useMemo(
        () =>
            createDictationSaveTracker(report =>
                handleEvent("dictation-save", { source, ...report }),
            ),
        [source],
    );
